import { render, staticRenderFns } from "./examenFisicoEmbarazoShow.vue?vue&type=template&id=44cb4c03"
import script from "./examenFisicoEmbarazoShow.vue?vue&type=script&lang=js"
export * from "./examenFisicoEmbarazoShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports